/* Remix Points: se una modifica al carrello (es. togli un prodotto) lascia senza punti i reward scelti, il server risponde 422.
   Qui togliamo i reward non piu coperti (dall'ultimo aggiunto) e rieseguiamo la modifica richiesta dal cliente
   (le chiavi delle righe cambiano dopo ogni modifica, quindi le ricalcoliamo). */
(function () {
  if (window.__rpFx || !window.fetch) return; window.__rpFx = 1;
  const of = window.fetch.bind(window);
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const isMut = (url, init) => /\/cart\/(change|update)(\.js)?(\?|$)/.test(url) && init && String(init.method || '').toUpperCase() === 'POST';
  const getCart = () => of(`${root()}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
  const tok = (items) => { const cnt = {}, o = {}; items.forEach((i) => { const n = cnt[i.variant_id] = (cnt[i.variant_id] || 0) + 1; o[i.key] = i.variant_id + '#' + n; }); return o; };
  function remapKey(k, oldT, newItems) { const t = oldT[k]; if (!t) return k; const nt = tok(newItems); for (const nk in nt) if (nt[nk] === t) return nk; return k; }
  function remapBody(body, oldItems, newItems) {
    let p; try { p = JSON.parse(body); } catch (_) { return body; }
    const oldT = tok(oldItems);
    if (p && typeof p.id === 'string' && p.id.indexOf(':') > -1) p.id = remapKey(p.id, oldT, newItems);
    else if (p && typeof p.line === 'number' && oldItems[p.line - 1]) { p.id = remapKey(oldItems[p.line - 1].key, oldT, newItems); delete p.line; }
    if (p && p.updates && typeof p.updates === 'object' && !Array.isArray(p.updates)) {
      const u = {}; for (const k in p.updates) u[k.indexOf(':') > -1 ? remapKey(k, oldT, newItems) : k] = p.updates[k]; p.updates = u;
    }
    return JSON.stringify(p);
  }
  async function stripOne() {
    const cart = await getCart();
    const rewards = (cart.items || []).filter((i) => i.properties && i.properties._remix_reward === 'true');
    if (!rewards.length) return false;
    const last = rewards[rewards.length - 1];
    const r = await of(`${root()}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: last.key, quantity: last.quantity - 1 }) });
    return r.ok;
  }
  window.fetch = async function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const res = await of(input, init);
    if (res.status !== 422 || !isMut(url, init) || typeof input !== 'string' || typeof init.body !== 'string') return res;
    let msg = '';
    try { const j = await res.clone().json(); msg = j.message || j.description || ''; } catch (_) {}
    if (!/Remix Points/i.test(msg)) return res;
    let snapshot; try { snapshot = (await getCart()).items || []; } catch (_) { return res; }
    let last = res;
    for (let n = 0; n < 6 && last.status !== 200; n++) {
      if (!(await stripOne())) break;
      let now; try { now = (await getCart()).items || []; } catch (_) { break; }
      last = await of(input, Object.assign({}, init, { body: remapBody(init.body, snapshot, now) }));
      if (last.ok) break;
    }
    if (last.ok) {
      const el = document.querySelector('remix-points');
      if (el && el.notice) el.notice('Reward rimosso: i punti non bastavano più.');
      document.dispatchEvent(new CustomEvent('cart:build'));
    }
    return last;
  };
})();

if (!customElements.get('remix-points')) {
  customElements.define('remix-points', class RemixPoints extends HTMLElement {
    connectedCallback() {
      this.rate = Number(this.dataset.pointsPerUnit) || 10;
      this.busy = false;
      this.addEventListener('click', (event) => this.onClick(event));
      this._cartListener = (event) => event.detail && event.detail.cart ? this.render(this.state(event.detail.cart)) : this.refresh();
      this._buildListener = () => setTimeout(() => { if (!this.busy) this.refresh(); }, 400);
      document.addEventListener('cart:updated', this._cartListener);
      document.addEventListener('cart:build', this._buildListener);
      this.refresh();
    }
    disconnectedCallback() { document.removeEventListener('cart:updated', this._cartListener); document.removeEventListener('cart:build', this._buildListener); }
    state(cart) {
      const cards = [...this.querySelectorAll('[data-rp-reward]')];
      const rewardIds = new Set(cards.map((el) => String(el.dataset.variantId)));
      let eligibleCents = 0, spent = 0;
      const quantities = new Map();
      for (const item of cart.items || []) {
        const id = String(item.variant_id), claim = item.properties && item.properties._remix_reward === 'true';
        if (rewardIds.has(id)) {
          /* ogni riga reward consuma punti, anche se aggiunta senza passare dal selettore */
          const card = this.querySelector(`[data-variant-id="${CSS.escape(id)}"]`);
          spent += (Number(card.dataset.points) || 0) * item.quantity;
          const prev = quantities.get(id);
          quantities.set(id, { quantity: (prev ? prev.quantity : 0) + item.quantity, key: claim || !prev ? item.key : prev.key });
        } else if (!claim) eligibleCents += Number(item.final_line_price) || 0;
      }
      const earned = Math.floor(eligibleCents / 10);
      return { earned, spent, available: earned - spent, quantities };
    }
    async refresh() {
      try {
        const cart = await fetch(`${window.Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
        this.render(this.state(cart)); return cart;
      } catch (_) { this.notice('Non riesco ad aggiornare i punti. Riprova.'); }
    }
    render(state) {
      this.current = state;
      this.querySelector('[data-rp-earned]').textContent = state.earned;
      this.querySelector('[data-rp-spent]').textContent = state.spent;
      this.querySelector('[data-rp-available]').textContent = Math.max(0, state.available);
      this.querySelector('[data-rp-meter]').style.width = `${state.earned ? Math.min(100, state.spent / state.earned * 100) : 0}%`;
      const notice = this.querySelector('[data-rp-notice]');
      if (state.available < 0 && notice && !notice.dataset.tmp) notice.textContent = `Hai usato ${-state.available} punti in più: togli un reward o aggiungi prodotti.`;
      else if (notice && !notice.dataset.tmp) notice.textContent = '';
      for (const card of this.querySelectorAll('[data-rp-reward]')) {
        const id = String(card.dataset.variantId), points = Number(card.dataset.points), max = Number(card.dataset.maxQuantity) || 99, selected = state.quantities.get(id);
        const missing = Math.max(0, points - state.available);
        const quantity = selected ? selected.quantity : 0;
        card.classList.toggle('is-locked', missing > 0 && !selected);
        card.querySelector('[data-rp-quantity]').textContent = quantity;
        card.querySelector('[data-rp-minus]').disabled = !selected || this.busy;
        card.querySelector('[data-rp-plus]').disabled = missing > 0 || this.busy || quantity >= max;
        card.querySelector('[data-rp-hint]').textContent = selected ? 'Nel carrello ✓' : (missing ? `Ti mancano ${missing} punti · aggiungi €${Math.ceil(missing / this.rate)}` : 'Disponibile ora');
      }
    }
    async onClick(event) {
      const card = event.target.closest('[data-rp-reward]'); if (!card || this.busy) return;
      const id = String(card.dataset.variantId), selected = this.current && this.current.quantities.get(id);
      if (event.target.closest('[data-rp-plus]')) {
        if (this.current.available < Number(card.dataset.points)) return;
        await this.change(id, selected ? selected.quantity + 1 : 1, selected && selected.key);
      } else if (event.target.closest('[data-rp-minus]') && selected) await this.change(id, selected.quantity - 1, selected.key);
    }
    async change(variantId, quantity, key) {
      this.busy = true; this.setAttribute('aria-busy', 'true');
      try {
        const path = key ? 'cart/change.js' : 'cart/add.js';
        const body = key ? { id: key, quantity } : { items: [{ id: Number(variantId), quantity, properties: { _remix_reward: 'true' } }] };
        const response = await fetch(`${window.Shopify.routes.root}${path}`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        if (!response.ok) throw new Error('cart');
        const cart = await this.refresh();
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      } catch (_) { this.notice('Reward non disponibile. Controlla il carrello e riprova.'); }
      finally { this.busy = false; this.removeAttribute('aria-busy'); if (this.current) this.render(this.current); }
    }
    notice(message) { const el = this.querySelector('[data-rp-notice]'); el.dataset.tmp = '1'; el.textContent = message; setTimeout(() => { el.textContent = ''; delete el.dataset.tmp; }, 4000); }
  });
}